import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Caption01, SingleLineEllipsis } from 'components/styles';
const PrimaryTitle = styled.div``;
const SecondaryTitle = styled.div`
  ${Caption01};
  ${SingleLineEllipsis};
  opacity: 0.5;
`;
export const ModalTitle = ({ primaryTitle, secondaryTitle })=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PrimaryTitle, {
                children: primaryTitle
            }),
            secondaryTitle ? /*#__PURE__*/ _jsx(SecondaryTitle, {
                children: secondaryTitle
            }) : null
        ]
    });
};
